import React from "react";

function VideoIcon() {
  return (
    <svg
      width="25"
      height="17"
      viewBox="0 0 25 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.25 3.25L16.25 8.25L23.25 13.25V3.25Z"
        stroke="#667085"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 1.25H3.25C2.14543 1.25 1.25 2.14543 1.25 3.25V13.25C1.25 14.3546 2.14543 15.25 3.25 15.25H14.25C15.3546 15.25 16.25 14.3546 16.25 13.25V3.25C16.25 2.14543 15.3546 1.25 14.25 1.25Z"
        stroke="#667085"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default VideoIcon;
